<template>
    <div class="custom-box pt-8 sl:pt-12 pb-12 sl:pb-20 mx-4 px-4 md:px-6 lg:mx-0 xl:px-0">
        <!-- <step
            titleColor="green"
            otherClass="first-step"
        >
            <p slot="title">Step 1</p>
            <p slot="text">Select the animal type</p>
        </step> -->
        <div class="text-center mb-6 sl:mb-10">
            <h2 class="text-xl md:text-2xl sl:text-4xl text-blue-100 font-bold">Select The Animal Type</h2>
        </div>
        <div class="w-full xl:w-11/12 2xl:w-4/5 mx-auto">
            <div class="grid grid-cols-2 xl:grid-cols-4 gap-4 lg:gap-10 2xl:px-12 py-4">
                <div
                    id="Broiler"
                    class="rounded-30 cursor-pointer border-2 flex flex-col items-center bg-gray-600 px-2 md:px-4 py-8 sl:py-12 text-center flex-1 w-full"
                    :class="selectedAnimal == 'Broiler' ? 'shadow-lg border-brand-100' : 'border-gray-300 '"
                    @click="animalSelected"
                >
                    <img
                        src="/images/meat-poultry.svg"
                        alt="broiler"
                        class=" w-16 md:w-auto"
                    >
                    <p class="text-black text-base md:text-2xl font-medium mt-4 md:mt-6 2xl:mt-10">Broilers</p>
                </div>
                <div
                    id="Layer"
                    class="rounded-30 cursor-pointer border-2 flex flex-col items-center bg-gray-600 px-2 md:px-4 py-8 sl:py-12 text-center flex-1 w-full"
                    :class="selectedAnimal == 'Layer' ? 'shadow-lg border-brand-100' : 'border-gray-300 '"
                    @click="animalSelected"
                >
                    <img
                        src="/images/egg-poultry.svg"
                        alt="layer"
                        class=" w-16 md:w-auto"
                    >
                    <p class="text-black text-base md:text-2xl font-medium mt-4 md:mt-6 2xl:mt-10">Layers</p>
                </div>
                <div
                    id="Swine"
                    class="rounded-30 cursor-pointer border-2 flex flex-col items-center bg-gray-600 px-2 md:px-4 py-8 sl:py-12 text-center flex-1 w-full"
                    :class="selectedAnimal == 'Swine' ? 'shadow-lg border-brand-100' : 'border-gray-300 '"
                    @click="animalSelected"
                >
                    <img
                        src="/images/swin.svg"
                        alt="swine"
                        class=" w-16 md:w-auto"
                    >
                    <p class="text-black text-base md:text-2xl font-medium mt-4 md:mt-6 2xl:mt-10">Swine</p>
                </div>
                <div
                    id="Aqua"
                    class="group relative rounded-30 cursor-pointer border-2 flex flex-col items-center bg-gray-600 px-2 md:px-4 py-8 sl:py-12 text-center flex-1 w-full"
                    :class="selectedAnimal == 'Aqua' ? 'shadow-lg border-brand-100' : 'border-gray-300'"
                    @click="animalSelected"
                >
                    <img
                        src="/images/aqua.svg"
                        alt="aqua"
                        class=" w-16 md:w-auto"
                    >
                    <p class="text-black text-base md:text-2xl font-medium mt-4 md:mt-6 2xl:mt-10">Fish</p>
                    <div
                        v-if="selectedProductVersion==='hiphorius'"
                        class=" group-hover:border-brand-100 flex-col absolute inset-0 py-8 bg-brand-100 text-white text-xl font-semibold rounded-30 border-2 border-gray-300 justify-evenly"
                        :class="selectedAnimal == 'Tilapia' || selectedAnimal == 'Seabream' || selectedAnimal == 'Trout' ? 'flex border-brand-100' : 'hidden group-hover:flex'"
                    >
                        <div
                            id="Tilapia" 
                            @click.stop="animalSelected"
                            class="px-6 py-4 hover:bg-brand-200"
                            :class="selectedAnimal == 'Tilapia' ? 'bg-brand-200' : ''"
                        >
                            Tilapia
                        </div>
                        <div
                            id="Seabream" 
                            @click.stop="animalSelected"
                            class="px-6 py-4 hover:bg-brand-200"
                            :class="selectedAnimal == 'Seabream' ? 'bg-brand-200' : ''"
                        >
                            Seabream
                        </div>
                        <div
                            id="Trout" 
                            @click.stop="animalSelected"
                            class="px-6 py-4 hover:bg-brand-200"
                            :class="selectedAnimal == 'Trout' ? 'bg-brand-200' : ''"

                        >
                            Trout
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    props: ["productGroup", "selectedProductVersion"],
    data() {
        return {
            selectedAnimal: this.productGroup
        };
    },
    methods: {
        animalSelected: function(event) {
            if (this.selectedProductVersion === 'hiphorius' && event.currentTarget.id === 'Aqua') return;
            this.selectedAnimal = event.currentTarget.id;
            this.$emit("animalSelected", this.selectedAnimal);
            // event.currentTarget.classList.add("selected");
        }
    }
};
</script>
<style>
.animal-tile {
    min-height: 200px;
    width: 100%;
    height: auto;
    border-radius: 7px;
}

.first {
    font-size: xx-large;
    min-height: 200px;
    width: 100%;
    height: auto;
    border-radius: 7px;
}

.second {
    font-size: xx-large;
    max-height: 400px;
    width: 100%;
    height: auto;
    border-radius: 7px;
}

.third {
    font-size: xx-large;
    max-height: 400px;
    width: 100%;
    height: auto;
    border-radius: 7px;
}

.iconImage {
    margin-top: 20px;
    height: auto;
    max-width: 100%;
    position: relative;
    width: auto;
}

.selected {
    box-shadow: 0px 0px 0px 7px #22a7f0;
}

#broilerImage {
    position: absolute;
    top: 65px;
    left: 10px;
    right: 10px;
    bottom: 15px;
    background-image: url("/images/Broiler Icon.jpg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

#layerImage {
    position: absolute;
    top: 65px;
    left: 10px;
    right: 10px;
    bottom: 15px;
    background-image: url("/images/layer.jpg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

#swineImage {
    position: absolute;
    top: 65px;
    left: 10px;
    right: 10px;
    bottom: 15px;
    background-image: url("/images/swine-h&s.jpg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
</style>
